<template>
  <div class="min-h-screen flex flex-col bg-gray-50">
    <div class="fixed w-full zindex">
      <Header class="zindex"  />
      <!-- py-2  -->
      <div class="w-full">
        <div class="bg-white border-bottom">
          <Navbar class="py-3" typeContainer="container-workspace" />
        </div>
        <!-- pl-10  -->
        <Breadcrumb class="mt-4 container-workspace bg-sfc" />
      </div>
    </div>
    <div class="flex-1 w-full max-w-full pt-10 bg-gray-50 relative overflow-x-hidden">
      <transition name="slide-fade" mode="out-in" appear>
        <router-view class="relative" />
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/UI/Navbar/Navbar";
import Header from "@/components/UI/Header";
import Footer from "@/components/UI/Footer";
import Breadcrumb from "@/components/UI/Breadcrumb";
export default {
  components: {
    Navbar,
    Header,
    Breadcrumb,
    Footer,
  },
  created() { },
};
</script>

<style>
.border-bottom {
  border-bottom: 1px solid #ddd;
}
.zindex {
  z-index: 999;
  position: relative;
}
</style>